import { render, staticRenderFns } from "./ParteListCard.vue?vue&type=template&id=4c5b6901&scoped=true"
import script from "./ParteListCard.vue?vue&type=script&lang=js"
export * from "./ParteListCard.vue?vue&type=script&lang=js"
import style0 from "./ParteListCard.vue?vue&type=style&index=0&id=4c5b6901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b6901",
  null
  
)

export default component.exports